/* eslint-disable no-unused-vars */
export enum Routes {
  // Common Routes
  Root = '/',

  // About Us
  Overview = '/overview',
  OurLeaders = '/our-leaders',
  OurJourney = '/our-journey',
  Awards = '/awards-achievements',
  DevelopmentOrientation = '/development-orientation',
  CompanyProfile = 'https://pione.asia/en/pione-group-profile-en.pdf',
  About = '/about',
  Team = '/team',
  WhyChoose = '/why-choose',

  // Services & Solutions
  IotAiBlockchain = '/iot-ai-blockchain',
  DigitalTransformation = '/digital-transformation',
  ApplicationDevelopment = '/application-development',
  UiUxDesignBranding = '/ui-ux-design-branding',
  WebsiteDevelopment = '/website-development',
  GamesDevelopment = '/game-development',

  // News & Events
  Blog = '/blog',
  News = '/news-events',
  // Events = '/news-events',
  // Newspaper = '/news-events',
  // MediaMarketing = '/news-events',

  // Careers & Culture
  CareersCulture = '/careers-culture',

  // Contact Us
  Contact = '/contact',

  // collaboration
  Collaboration = '/collaboration',

  // Policies
  TermsOfUse = '/terms-of-use',
  PrivacyPolicy = '/privacy-policy',
  CookiePolicy = '/cookie-policy',

  // Industrials & Technology
  PioneWallet = '/pione-wallet',
  PioneFarm = '/pione-farm',
  PioneCare = '/pione-care',
  PioneHouse = '/pione-house',
  PioneZero = '/pione-zero',
  PioneAI = '/pione-ai',
  PioneSuperApp = '/pione-super-app',
  PionePoAi = '/pione-poai',

  //Other
  Swap = 'https://pioneswap.com/',
  NFT = 'https://nft.pionewallet.com/',
  Wallet = 'https://pionewallet.com/',
  Farm = 'https://pionefarm.com/',
  Care = 'https://pionecare.com/',
  House = 'https://pionehouse.com/',
  Exchange = 'https://expione.com/',
  Mart = 'https://pionemart.com/',
  Chain = 'https://pionechain.com/',
  Star = '/star',
  Node = '/node',
  AI = '/ai',
  Smart = '/smart',
  Dapps = '/dapps'
}

export const getCompanyProfileRoute = (locale: string): string => {
  console.log(locale, 'localeinroute')
  return locale === 'vi' ?
      'https://pione.asia/vi/pione-group-profile-vi.pdf'
    : 'https://pione.asia/en/pione-group-profile-en.pdf'
}
